module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Comprovantes")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12 min-content"
  }, [_c('ul', [_c('li', {
    staticClass: "content-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "request-kind-block"
  }, [_c('router-link', {
    staticClass: "purple",
    attrs: {
      "tag": "a",
      "to": {
        name: 'transfer-shipper-voucher-detail'
      }
    }
  }, [_vm._v("\n              07348164723981\n            ")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-block"
  }, [_c('a', {
    staticClass: "btn btn-back btn-line",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Imprimir comprovante"
    }
  }, [_c('i', {
    staticClass: "icon-printer"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-back btn-line",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Baixar comprovante em PDF"
    }
  }, [_c('i', {
    staticClass: "icon-pdf"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-block"
  }, [_c('small', {
    staticClass: "label-information"
  }, [_vm._v("Tipo de Transação")]), _vm._v(" "), _c('div', {
    staticClass: "label-category"
  }, [_vm._v("Transferência de Crédito")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "favored-block"
  }, [_c('small', {
    staticClass: "label-information"
  }, [_vm._v("Favorecido")]), _vm._v(" "), _c('div', {
    staticClass: "label-favored"
  }, [_vm._v("Transfolha Transportes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-block green"
  }, [_vm._v("\n            R$ "), _c('b', [_vm._v("5.000,00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-block"
  }, [_c('div', {
    staticClass: "time-block"
  }, [_c('i', {
    staticClass: "icon-clock"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('div', [_vm._v("06/12/2017")]), _vm._v(" "), _c('div', [_vm._v("13:05")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-d079beac!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/shipper/transfer-shipper-vouchers.vue
// module id = 2216
// module chunks = 1